enum PageType {
  START = 'START',
  GENERATE_LYRICS_BY_THEME = 'GENERATE_LYRICS_BY_THEME',
  REWRITE_LYRICS = 'REWRITE_LYRICS',
}

export default PageType;
